module.exports = __webpack_public_path__ + "img/wait.e65834b8.svg";